module.exports = __webpack_public_path__ + "img/s1.3da31d17.png";